import { createAsyncThunk } from "@reduxjs/toolkit"

import { me } from "src/store/user"
import { getLobbies } from "src/store/lobby"
import { getGames } from "src/store/game"
import { getWallet } from "src/store/economy"

export const loadUserData = createAsyncThunk("auth/loadUserData", async (_, { dispatch, rejectWithValue }) => {
  try {
    // The wallet rides along with the rest of the bootstrap. It is not optional extra data: the
    // lobby needs `unlockedRaces` to know which class cards it may offer, and the header shows the
    // balance from the first paint — fetching it later means a lobby that briefly locks classes
    // the player owns.
    await Promise.all([
      dispatch(me()),
      dispatch(getLobbies()),
      dispatch(getGames()),
      dispatch(getWallet()),
    ])
    return
  } catch (error) {
    return rejectWithValue(error)
  }
})
